import React from 'react';
import {Route, Navigate, useLocation} from 'react-router-dom';
import WebPaymentsLoginRedirect from '@/routes/auth/WebPaymentsLoginRedirect';
import {screenNames} from '@/lib/delta/deltaConstants.js';
import {getEnv} from '@/config/environment';
import {ROUTES} from '@/config/routesConstants';
import AuthError from '@/views/auth/error';
import BrandsLogin from '@/views/auth/login';
import ExternalRedirect from '@/components/external-redirect/ExternalRedirect';

function RedirectWithQuery({to}: {to: string}) {
  const location = useLocation();
  return <Navigate to={`${to}${location.search}`} replace />;
}

function isWebPaymentLoginEnabled(useWebPaymentLogin: boolean) {
  return useWebPaymentLogin && !!getEnv().VITE_WEB_PAYMENT_LOGIN_URL;
}

function AuthRoutes({flags}: {flags: any}) {
  const salesSurveyUrl = getEnv().VITE_SALES_SURVEY_URL;
  const shouldUseWebPaymentLogin = isWebPaymentLoginEnabled(
    flags.enableWebPaymentsLoginPage
  );
  return (
    <>
      <Route
        path={ROUTES.LOGIN}
        element={
          shouldUseWebPaymentLogin ? (
            <WebPaymentsLoginRedirect />
          ) : (
            <BrandsLogin />
          )
        }
      />
      <Route
        path={ROUTES.SIGN_UP}
        element={
          <ExternalRedirect
            url={salesSurveyUrl}
            screenName={screenNames.AUTH.NEW_SIGNUP}
            source={ROUTES.SIGN_UP}
          />
        }
      />
      <Route
        path={ROUTES.SIGN_UP_REACT_OLD}
        element={<RedirectWithQuery to={ROUTES.SIGN_UP} />}
      />
      <Route path={ROUTES.AUTH_ERROR} element={<AuthError />} />
    </>
  );
}

export default AuthRoutes;
